import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";

const fetchEdiaryConfig = async ({ trialId }) => {
  const token = localStorage.getItem("token");

  const res = await axios.get(`${__API_URL__}/api/photos/ediary/config/${trialId}/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetEdiaryConfig = ({ trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["ediary_config", trialId],
    queryFn: () => fetchEdiaryConfig({ trialId }),
    enabled: enabled && Boolean(trialId),
    onError: (error) => {
      showApiErrorToast(error, "Failed to load the eDiary settings");
    },
  });
};

export default useGetEdiaryConfig;
